import { AlertTriangle, X } from 'lucide-react';
import { DialogBackdrop } from '../../../components/ui/dialog-backdrop';
import type { TenantSegmentConflict } from '../automations-tab/templates.types';
import styles from './SegmentAdditionConfirmDialog.module.css';

const TITLE = 'Add segments to tenants?';
const INTRO =
  "Saving gives these tenants segments they don't have yet, including segments they were excluded from, so the automation can run.";
const CONFIRM_LABEL = 'Save & sync';

interface SegmentAdditionConfirmDialogProps {
  conflicts: TenantSegmentConflict[];
  onClose: () => void;
  onConfirm: () => void;
}

export function SegmentAdditionConfirmDialog({
  conflicts,
  onClose,
  onConfirm,
}: SegmentAdditionConfirmDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <DialogBackdrop onClose={onClose} />
      <dialog className={styles.dialog} open>
        <header>
          <h2>{TITLE}</h2>
          <button onClick={onClose} type="button" aria-label="Close">
            <X />
          </button>
        </header>
        <main>
          <p>{INTRO}</p>
          <ul className={styles.tenantList}>
            {conflicts.map(conflict => (
              <SegmentAdditionItem key={conflict.tenantId} conflict={conflict} />
            ))}
          </ul>
        </main>
        <footer>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" onClick={handleConfirm} data-variant="warning">
            <AlertTriangle />
            {CONFIRM_LABEL}
          </button>
        </footer>
      </dialog>
    </>
  );
}

function SegmentAdditionItem({ conflict }: { conflict: TenantSegmentConflict }) {
  const segmentNames = conflict.missingSegments.map(segment => segment.name).join(', ');
  return (
    <li>
      <strong>{conflict.tenantName}</strong>
      {segmentNames}
    </li>
  );
}
